var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"id":"delete-profile"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var close = ref.close;
return [_c('h2',[_vm._v(_vm._s(_vm.$t('ModalDeleteProfileTitle')))]),_c('div',{staticClass:"actions"},[_c('button',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('yes')))]),_c('button',{on:{"click":close}},[_vm._v(_vm._s(_vm.$t('cancel')))])])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }